var React = require('react');

function IconGroupingSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M496 920L101 683.5c-5-3-6.8-9.4-4-14.6l21.7-40.1c2.9-5.3 9.5-7.3 14.8-4.4.1.1.3.1.4.2l372.5 223c3.5 2.1 7.8 2.1 11.2 0l371.8-223c5.2-3.1 11.9-1.4 15 3.7.1.1.1.2.2.4l22 39.9c2.8 5.1 1.1 11.6-3.9 14.6L528.3 919.9l-10.9 6c-3.3 1.8-7.2 1.8-10.5 0L496 920zm0-176.7L115.3 516c-5-3-6.8-9.4-4-14.6l21.7-40.1c2.9-5.3 9.5-7.3 14.8-4.4.1.1.3.1.4.2l358.5 214.3c3.4 2 7.7 2.1 11.1 0l363.8-214.5c5.2-3.1 11.9-1.3 14.9 3.9.1.1.1.2.2.3l22 39.9c2.8 5.2 1.1 11.7-4 14.7L528.3 743.2l-10.9 6c-3.3 1.8-7.2 1.8-10.5 0l-10.9-5.9zM150.4 309.8l-36.6 19.6c-10.3 5.6-10.1 14.7 0 20.1l36.6 19.6L497.3 576c8.7 4.7 23.7 4.3 31.6.2l343.8-206.9 39-20.4c10-5.2 9.1-14.1 0-18.9l-39-20.4-343.8-207.1c-8.7-4.6-23.7-4.1-31.6.2L150.4 309.8z"}));
}

IconGroupingSolid.displayName = "IconGroupingSolid";

IconGroupingSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconGroupingSolid;

IconGroupingSolid.default = IconGroupingSolid;
